import React from 'react';

import ComparisonTable, {
  ComparisonTableContent,
} from '@/components/ComparisonTable/Table/ComparisonTable';
import ComparisonTableMobile from '@/components/ComparisonTable/Table/Mobile/ComparisonTableMobile';
import { Contentful } from '@/contentful/types';
import useScreenSize from '@/hooks/deviceWidth';

import useStyles from './ComparisonTableContainer.style';

export interface ComparisonTableContainerContent extends Contentful {
  fields: {
    title: string;
    subtitle: string;
    comparisonTables: ComparisonTableContent[];
  };
}

interface Props {
  content: ComparisonTableContainerContent;
}

/**
 * @deprecated V2 component
 */
const ComparisonTableContainer: React.FC<Props> = ({ content }) => {
  const { classes } = useStyles();
  const { title, subtitle, comparisonTables } = content.fields;
  const { isTable, isLarge, isXLarge } = useScreenSize();

  const isSmoll = isTable;

  const renderTable = (
    comparisonTable: ComparisonTableContent
  ): React.JSX.Element => {
    switch (true) {
      case isLarge:
        return <ComparisonTable content={comparisonTable} />;
      case isXLarge:
        return <ComparisonTable content={comparisonTable} />;
      default:
        // Fallback for unsupported resolutions
        return <ComparisonTable content={comparisonTable} />;
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.heading}>
        <div className={classes.title}>{title}</div>
        <div className={classes.subtitle}>{subtitle}</div>
      </div>
      <div className={classes.tables}>
        {!isSmoll &&
          comparisonTables.map((comparisonTable, index) => (
            <React.Fragment key={index}>
              {renderTable(comparisonTable)}
            </React.Fragment>
          ))}
        {isSmoll && <ComparisonTableMobile content={comparisonTables} />}
      </div>
    </div>
  );
};

export default ComparisonTableContainer;
